import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGnosisSafeIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 310 310"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M155.089 8.46C42.282 8.475-28.205 130.601 28.211 228.287c56.417 97.686 197.425 97.667 253.815-.034A146.545 146.545 0 0 0 301.649 155c0-80.939-65.621-146.551-146.56-146.54ZM262.359 163h-68c-6.243 31.26-43.985 44.039-67.936 23.002-23.95-21.037-16.146-60.112 14.048-70.335 24.374-8.253 50.293 7.489 54.208 32.923h67.68c5.546-.207 9.237 5.668 6.642 10.575a7.209 7.209 0 0 1-6.642 3.835Z" />
  </svg>
);
export default SvgGnosisSafeIcon;
